const DEFAULT_MOBILE_BREAKPOINT = 768;

export const isMobileScreen = (
  breakpoint = DEFAULT_MOBILE_BREAKPOINT,
  width = window.innerWidth
) => {
  return width < Number(breakpoint);
};

export const bindScreenResize = (context, breakpointOrGetter = DEFAULT_MOBILE_BREAKPOINT) => {
  const getBreakpoint =
    typeof breakpointOrGetter === 'function' ? breakpointOrGetter : () => breakpointOrGetter;

  const update = () => {
    context.isMobileScreen = isMobileScreen(getBreakpoint());
  };

  update();
  window.addEventListener('resize', update);

  return () => {
    window.removeEventListener('resize', update);
  };
};
